import React, { Suspense } from "react";
import CatalogueMainProducts from "~/modules/catalogue/components/CatalogueMainProducts";
import FloatingButtonCart from "~/modules/catalogue/components/FloattingButtonCart/FloatingButtonCart";
import {
  useAppParams,
  useStoreImages,
  WidgetCaller,
  WidgetType } from
"@commons-monorepo/index";
import { BreadcrumbsRoute } from "~/components/breadcrumbs/breadcrumbs.types";
import { InternalView } from "~/components/internal-view/internal-view";
import { V2_MetaFunction } from "@remix-run/node";
import styles from "./partner.module.css";
import { Await, useLoaderData, useOutletContext } from "@remix-run/react";
import { ProductsSkeleton } from "~/components/products-skeleton/products-skeleton";
import { useCart } from "~/modules/cart/providers/cart.provider";
import EmptyState from "~/components/empty-states/empty-state/empty-state";
import { useTranslation } from "react-i18next";
import { categoryUnformat, isEmpty } from "@commons-monorepo/index";
import { useGlobalStyles } from "~/styles/context/global-styles-wrapper";
import { BestCategory } from "~/common/props/orchestrator";

export const categoryMetaData: V2_MetaFunction = ({ params, matches }) => {
  const { t } = useTranslation();
  const parentsData = matches[0]?.data;
  const { bestCategories } = matches[1]?.data?.categoriesResponse;
  const storeMetadata = parentsData?.storeMetadata;
  const city = storeMetadata?.storeCity;
  const country = storeMetadata?.country;
  const title = categoryUnformat(
    (params.subcategoryId ?? params.categoryId) || ""
  );
  const { partnerProfilePicture } = useStoreImages(storeMetadata);
  const description = parentsData?.description;
  const customTitle = `${t("meta_category.title", { name: title, city })}`;
  const customDescription = `${t("meta_category.description", {
    name: title,
    city,
    country
  })}`;
  const getCategory = (): BestCategory =>
  bestCategories?.find(
    (category: BestCategory) =>
    category.id === categoryUnformat(params.categoryId ?? "")
  );

  return [
  { name: "charset", content: "utf-8" },
  { title: customTitle },
  { name: "description", content: customDescription },
  {
    name: "viewport",
    content: "width=device-width,initial-scale=1,maximum-scale=1"
  },
  { name: "og:title", content: title },
  {
    name: "og:image",
    content: getCategory()?.image || partnerProfilePicture
  },
  { name: "og:description", content: description }];

};

const Index = () => {
  const params = useAppParams();
  const {
    categoryId: categoryIdNormalized,
    subcategoryId: subcategoryIdNormalized
  } = params;
  const { paginatedData } = useLoaderData();
  const { cartProducts, removeProduct, manuallyChangeProduct, addProduct } =
  useCart();
  const { theme } = useGlobalStyles();
  const { storeMetadata } = useOutletContext<any>();
  const cart = {
    cartProducts,
    removeProduct,
    manuallyChangeProduct,
    addProduct
  };
  const localConfig = {
    cart: cart,
    locale: storeMetadata?.locale,
    currency: storeMetadata?.currency
  };

  const categoryId = categoryUnformat(categoryIdNormalized || "");
  const subcategoryId = categoryUnformat(subcategoryIdNormalized || "");
  const categoryName =
  paginatedData?.products[0]?.categoryDetail?.name || categoryId;
  const categoryTitle = `${
  categoryName.charAt(0).toUpperCase() + categoryName.toLowerCase().slice(1)
  }${
  subcategoryId ?
  ` - ${
  subcategoryId.charAt(0).toUpperCase() +
  subcategoryId.toLowerCase().slice(1)
  }` :
  ""
  }`;

  const breadcrumbsRoutes = (): BreadcrumbsRoute[] => {
    const routes: BreadcrumbsRoute[] = [];
    if (!!categoryId) {
      const nameCategory = (categoryTitle || "").trim();
      routes.push({
        text: `${nameCategory.slice(0, 30)}${
        nameCategory.length > 30 ? "..." : ""
        }`
      });
    }
    return routes;
  };

  return (
    <div className={styles.wrapperContainer}>
      <Suspense
        fallback={
        <div className={styles.desktopGrid}>
            <InternalView
            copy={categoryTitle}
            breadcrumbs={breadcrumbsRoutes()}>

              <div className={styles.categoryGrid}>
                <ProductsSkeleton number={4} />
              </div>
            </InternalView>
          </div>}>


        <Await resolve={paginatedData} errorElement={<h1>Hola</h1>}>
          {(pd) =>
          <InternalView
            copy={categoryTitle}
            breadcrumbs={breadcrumbsRoutes()}>

              <div className={styles.categoryGrid}>
                {cartProducts.length >= 1 && <FloatingButtonCart />}
                {!isEmpty(pd.products) ?
              <CatalogueMainProducts
                data={pd?.products}
                theme={theme}
                localConfig={localConfig}
                caller={WidgetCaller.CatalogueInternal}
                storeMetadata={storeMetadata}
                type={WidgetType.PRODUCTS_GRID_1}
                config={{ highlight_background: false }} /> :


              <EmptyState searchProduct />}

              </div>
            </InternalView>}

        </Await>
      </Suspense>
    </div>);

};

export default Index;